<template>
  <div class="boarding-detail-page">
    <div class="page-header">
      <span class="page-title">寄宿托养订单详情</span>
      <el-button type="primary" plain size="small" icon="el-icon-back" @click="returnFn()">返回列表</el-button>
    </div>
    <div class='descriptionsBox' v-loading="detailLoading" element-loading-text="加载中..." element-loading-background="rgba(0, 0, 0, 0.6)">
      <div v-if="rowData.orderInfo" class="info-card mt20">
        <div class="info-card-head">
          <span class="info-card-title">订单信息</span>
          <span class='status-tag'>{{ rowData.orderInfo.order_status | boardingStatusFilter }}</span>
        </div>
        <el-descriptions class='mt15' :column='4' :colon="false">
          <el-descriptions-item label="订单编号">{{ rowData.orderInfo.order_no }}</el-descriptions-item>
          <el-descriptions-item label="服务名称" span="3">{{ rowData.orderInfo.service_name }}</el-descriptions-item>
          <el-descriptions-item label="订单创建时间">{{ (rowData.orderInfo.created_at * 1000) | formatDate('yyyy-MM-dd HH:mm:ss') }}</el-descriptions-item>
        <el-descriptions-item v-if="rowData.couponInfo && rowData.couponInfo.coupon_batch" label="优惠券批次号">{{ rowData.couponInfo.coupon_batch }}</el-descriptions-item>
        <el-descriptions-item v-if="rowData.couponInfo && rowData.couponInfo.coupon_batch" label="优惠券名称">{{ `优惠${ rowData.couponInfo.discount_num === 1 || rowData.couponInfo.discount_num === 0 ? '单': rowData.couponInfo.discount_num}次，每次优惠${rowData.couponInfo.discount}元`}}</el-descriptions-item>
          <el-descriptions-item v-if="rowData.couponInfo && rowData.couponInfo.coupon_batch" label="优惠总金额">{{ `￥${(rowData.couponInfo.discount_num * rowData.couponInfo.discount).toFixed(2)}`}}</el-descriptions-item>
        </el-descriptions>
      </div>
      <div v-if="rowData.userInfo" class="info-card mt20">
        <div class="info-card-head">
          <span class="info-card-title">被服务人信息</span>
          <el-button v-if="showChangeOrderPatientInfo && canEditPatientInfo" type="primary" size="small" @click="handleOpenChangeOrderPatientInfo">修改被服务人信息</el-button>
        </div>
        <el-descriptions class='mt15' :column='4' :colon="false">
          <el-descriptions-item label="姓名">{{ rowData.userInfo.name }}</el-descriptions-item>
          <el-descriptions-item label="性别">{{ rowData.userInfo.sex | sexFilter }}</el-descriptions-item>
          <el-descriptions-item label="年龄">{{ rowData.userInfo.age }}</el-descriptions-item>
          <el-descriptions-item label="监护人电话">{{ rowData.userInfo.tel }}</el-descriptions-item>
          <el-descriptions-item label="服务类型">{{ rowData.userInfo.cri_type | criTypeFilter }}</el-descriptions-item>
          <el-descriptions-item v-if="rowData.orderInfo && rowData.orderInfo.id_card" label="残疾证">{{ rowData.orderInfo.id_card }}</el-descriptions-item>
          <el-descriptions-item label="地址">{{ rowData.userInfo.address }}</el-descriptions-item>
          <el-descriptions-item v-if="rowData.orderInfo && rowData.orderInfo.dis_grade" label="残疾等级">{{ rowData.orderInfo.dis_grade | disGradeFilter }}</el-descriptions-item>
          <el-descriptions-item v-if="rowData.orderInfo && rowData.orderInfo.img_urls && imgUrlsList.length" label="残疾证照">
            <div class="cert-imgs">
              <el-image v-for="(url, index) in imgUrlsList" :key="index" :src="url" :preview-src-list="imgUrlsList" class="cert-img" fit="cover" />
            </div>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div class="info-card mt20">
        <div class="info-card-head">
          <span class="info-card-title">护工信息</span>
          <el-button v-if="canAssignCaregiver" type="primary" size="small" @click="handleOpenChangeOrderNurseInfo">指/改派护工</el-button>
        </div>
        <el-descriptions class='mt15' :column='5' :colon="false">
          <template v-if="rowData.nurseInfo && rowData.nurseInfo.length > 0">
            <el-descriptions-item label="姓名">{{ nurseInfoItem(rowData.nurseInfo[0], 'name') }}</el-descriptions-item>
            <el-descriptions-item label="手机号">{{ nurseInfoItem(rowData.nurseInfo[0], 'tel') }}</el-descriptions-item>
          </template>
          <el-descriptions-item v-else label="姓名"><span class="empty-text">未指派</span></el-descriptions-item>
        </el-descriptions>
      </div>

      <template v-if="showNursingRecords">
        <div class="info-card mt20">
          <div class="info-card-head">
            <span class="info-card-title">服务记录</span>
          </div>
          <el-table class="record-table" :data="rowData.nurseRecordsInfo || []" style="width: 100%" :header-cell-style="{ background: '#fafafa', color: '#303133' }">
            <template slot="empty">
              <span class="empty-text">暂无服务记录</span>
            </template>
            <el-table-column minWidth="50" label="序号" align="center">
              <template slot-scope="scope">{{ scope.$index + 1 }}</template>
            </el-table-column>
            <el-table-column minWidth="120" label="护士信息">
              <template slot-scope="{ row }">
                <div class="nurse-cell">
                  <div class="nurse-name">{{ row.name || '—' }}</div>
                  <div class="nurse-tel">{{ row.tel || '—' }}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column minWidth="120" label="服务时间">
              <template slot-scope="scope">
                <span v-if="scope.row.service_at">{{ (scope.row.service_at * 1000) | formatDate('yyyy-MM-dd') }}</span>
                <span v-else-if="scope.row.dis_start_at">{{ (scope.row.dis_start_at * 1000) | formatDate('yyyy-MM-dd') }}</span>
                <span v-else class="empty-text">—</span>
              </template>
            </el-table-column>
            <el-table-column minWidth="120" label="服务类型">
              <template slot-scope="scope">
                <el-tag size="mini" type="info" effect="plain">{{ recordServiceType(scope.row) }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column minWidth="110" label="考勤情况" align="center">
              <template slot-scope="scope">
                <el-tag v-if="attendanceText(scope.row) !== '—'" size="mini" :type="attendanceTagType(scope.row)" effect="dark">{{ attendanceText(scope.row) }}</el-tag>
                <span v-else class="empty-text">—</span>
              </template>
            </el-table-column>
            <el-table-column minWidth="200" label="服务内容" class-name="service-item-col">
              <template slot-scope="scope">
                <div v-if="showRecordServiceDetail(scope.row) && serviceItemNames(scope.row).length" class="service-list">
                  <div v-for="(name, i) in serviceItemNames(scope.row)" :key="i" class="service-line">{{ name }}</div>
                </div>
                <span v-else class="empty-text">—</span>
              </template>
            </el-table-column>
            <el-table-column minWidth="200" label="服务中照片">
              <template slot-scope="scope">
                <div class="imgbox" v-if="showRecordServiceDetail(scope.row) && recordImgs(scope.row).length">
                  <el-image
                    class='litimg2'
                    v-for="img in recordImgs(scope.row)"
                    :src="img"
                    :key="img"
                    fit="cover"
                    :preview-src-list="recordImgs(scope.row)">
                  </el-image>
                </div>
                <span v-else class="empty-text">—</span>
              </template>
            </el-table-column>
            <el-table-column v-if="canEditRecord && (canEditServiceRecord || canDeleteServiceRecord)" minWidth="100" label="操作" align="center">
              <template slot-scope="scope">
                <el-link v-if="canEditServiceRecord" type="primary" style="margin-right: 16px" @click="openEditRecord(scope.row)">
                  <i class="el-icon-edit"></i>
                </el-link>
                <el-link v-if="canDeleteServiceRecord && scope.$index ===  rowData.nurseRecordsInfo.length - 1" type="danger" @click="handleDelete(scope.row.id)">
                  <i class="el-icon-delete"></i>
                </el-link>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </template>

      <div v-if="rowData.cancelOrderInfo && !Array.isArray(rowData.cancelOrderInfo) && showCancelOrderInfo" class="info-card mt20">
        <div class="info-card-head">
          <span class="info-card-title">取消订单</span>
          <el-button v-if="showCancelOrder" type="primary" size="small" @click="handleOpenCancelOrder">结束服务</el-button>
        </div>
        <el-descriptions class='mt15' :column='4' :colon="false">
          <el-descriptions-item label="申请退款时间">{{ (rowData.cancelOrderInfo.refund_at * 1000) | formatDate('yyyy-MM-dd HH:mm') }}</el-descriptions-item>
          <el-descriptions-item label="总服务天数">{{ rowData.cancelOrderInfo.service_days_num }}</el-descriptions-item>
          <el-descriptions-item label="已服务天数">{{ rowData.cancelOrderInfo.nurse_records_num }}</el-descriptions-item>
          <el-descriptions-item label="应退款金额"><span class="refund-fee">￥{{ rowData.cancelOrderInfo.refund_fee }}</span></el-descriptions-item>
          <el-descriptions-item v-if="rowData.orderInfo && rowData.orderInfo.order_status === OrderAllStatus[5].val && delayTime" label="等待审核">
            <span class="delay-time">{{ delayTime }}</span>
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </div>
    <ChangeOrderPatientInfo ref="ChangeOrderPatientInfo" :type="type" @update="getList" />
    <ChangeOrderNurseInfo ref="ChangeOrderNurseInfo" @update="getList" />
    <CancelOrder ref="CancelOrder" @update="getList" />
    <EditServiceRecord ref="EditServiceRecord" :order-id="rowDataId" :dir="disDir" @success="getList" />
  </div>
</template>

<script>
import { fetchBoardingOrderDetail, delBoardingServiceRecord, fetchCriArticleServices } from '@/api'
import { filterEnum } from '../../utils/filter'
import { DisabilityTypes, OrderAllStatus, OrderPayTypes } from '../../enum/orders'
import ChangeOrderPatientInfo from './components/ChangeOrderPatientInfo'
import ChangeOrderNurseInfo from '../orders/components/ChangeOrderNurseInfo'
import CancelOrder from '../orders/components/CancelOrder'
import EditServiceRecord from './components/EditServiceRecord'
import { formatDate } from 'element-ui/lib/utils/date-util'
import { getBoardingChildRoleIds, hasBoardingAssignNurse, isAdmin } from '../../utils/util'

const BoardingStatusMap = {
  1: '待服务',
  2: '已失效',
  10: '待服务',
  20: '待服务',
  30: '服务中',
  40: '待处理',
  50: '已取消',
  60: '已完成',
  41: '拒绝退款'
}
const SexMap = { '1': '男', '2': '女' }
const CriTypeMap = { '1': '日间照料', '2': '寄宿托养' }
const DisGradeMap = { '1': '一级', '2': '二级', '3': '三级', '4': '四级', '5': '未分级' }

export default {
  name: 'OrdersBoardingDetail',
  components: { CancelOrder, ChangeOrderNurseInfo, ChangeOrderPatientInfo, EditServiceRecord },
  data() {
    const isDate = new Date()
    return {
      OrderAllStatus,
      type: '',
      rowDataId: '',
      delayTime: Date.now(),
      fileList: [],
      thisDateS: `${isDate.getFullYear()}-${isDate.getMonth() + 1}-${isDate.getDate()}`,
      thisDate: Date.parse(`${isDate.getFullYear()}/${isDate.getMonth() + 1}/${isDate.getDate()} 00:00:00`),
      rowData: {
        orderInfo: null,
        userInfo: null,
        nurseInfo: [],
        nurseRecordsInfo: [],
        couponInfo: {},
        cancelOrderInfo: null
      },
      detailLoading: false,
      editVisible: false,
      editForm: {
        id: '',
        nurse: '',
        inServicePicture: '',
        brokerage: '',
        selfcareAbility: '',
        modificationTime: `${isDate.getFullYear()}-${isDate.getMonth() + 1}-${isDate.getDate()} ${isDate.getHours()}:${isDate.getMinutes()}`,
        nurse_tel: ''
      },
      editFormTitle: '',
      formLabelWidth: '153px',
      tableDataAdd: {},
      timer: null,
      serviceCatalog: []
    }
  },
  filters: {
    formatDate,
    boardingStatusFilter(val) {
      return BoardingStatusMap[val] || '-'
    },
    sexFilter(val) {
      return SexMap[String(val)] || (val || '-')
    },
    criTypeFilter(val) {
      return CriTypeMap[String(val)] || (val || '-')
    },
    disGradeFilter(val) {
      return DisGradeMap[String(val)] || (val || '-')
    },
    disabilityTypesFilter(val) {
      return filterEnum(val, DisabilityTypes).label
    },
    orderPayTypesFilter(val) {
      return filterEnum(val, OrderPayTypes).label || '-'
    }
  },
  computed: {
    isAdmin() {
      return isAdmin()
    },
    criRoleArr() {
      return getBoardingChildRoleIds(this.$store.state.rules)
    },
    canEditPatientInfo() {
      return this.isAdmin || this.criRoleArr.includes('4')
    },
    canAssignCaregiver() {
      // 寄宿托养「指/改派护工」对应 cri_role=1（不是失能的 7）
      return this.isAdmin || this.criRoleArr.includes('1') || this.criRoleArr.includes('7') || hasBoardingAssignNurse(this.$store.state.rules)
    },
    canEditServiceRecord() {
      return this.isAdmin || this.criRoleArr.includes('5')
    },
    canDeleteServiceRecord() {
      return this.isAdmin || this.criRoleArr.includes('6')
    },
    showNursingRecords() {
      const { order_status } = this.rowData.orderInfo || {}
      const trueList = [OrderAllStatus[3].val, OrderAllStatus[7].val, OrderAllStatus[4].val, OrderAllStatus[5].val, OrderAllStatus[6].val]
      return trueList.includes(order_status)
    },
    showCancelOrderInfo() {
      const { order_status } = this.rowData.orderInfo || {}
      const trueList = [OrderAllStatus[3].val, OrderAllStatus[5].val, OrderAllStatus[7].val]
      return trueList.includes(order_status)
    },
    showCancelOrder() {
      const { order_status } = this.rowData.orderInfo || {}
      const trueList = [OrderAllStatus[3].val, OrderAllStatus[5].val]
      return trueList.includes(order_status)
    },
    isDis() {
      return this.type === 'orders_foster' || this.type === 'orders_foster_records' || this.type === 'orders_boarding'
    },
    showChangeOrderPatientInfo() {
      const { order_status } = this.rowData.orderInfo || {}
      const trueList = [OrderAllStatus[2].val, OrderAllStatus[3].val, OrderAllStatus[5].val, OrderAllStatus[4].val]
      return trueList.includes(order_status)
    },
    canEditRecord() {
      const { order_status } = this.rowData.orderInfo || {}
      return order_status !== 60
    },
    disDir() {
      const oi = this.rowData.orderInfo || {}
      return oi.id_card || ''
    },
    imgUrlsList() {
      const urls = this.rowData.orderInfo && this.rowData.orderInfo.img_urls
      if (!urls) return []
      if (Array.isArray(urls)) return urls.filter(Boolean)
      return String(urls).split(',').filter(Boolean)
    }
  },
  mounted() {
    this.type = this.$route.query.type
    this.rowDataId = this.$route.query.id
    this.loadServiceCatalog()
    this.getList()
  },
  beforeDestroy() {
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
  },
  methods: {
    nurseInfoItem(item, key) {
      if (item && typeof item === 'object') return item[key] || '—'
      return '—'
    },
    async loadServiceCatalog() {
      try {
        const params = {}
        if (this.rowDataId) { const oid = Number(this.rowDataId); params.order_id = Number.isFinite(oid) ? oid : this.rowDataId }
        const { status, data } = await fetchCriArticleServices(params)
        if (status && data != null) {
          const rawList = Array.isArray(data) ? data : data.list || []
          this.serviceCatalog = rawList.map(r => ({
            id: r.id != null ? String(r.id) : (r.item_id != null ? String(r.item_id) : (r.service_id != null ? String(r.service_id) : '')),
            name: r.name || ''
          })).filter(r => r.id)
        }
      } catch (e) {
        this.serviceCatalog = []
      }
    },
    serviceItemNames(row) {
      if (!row) return []
      const si = row.service_item
      // 接口返回 [{ id, name }, ...]
      if (Array.isArray(si) && si.length) {
        return si.map(item => {
          if (item && typeof item === 'object') {
            return item.name || ''
          }
          const m = this.serviceCatalog.find(c => c.id === String(item))
          return m ? m.name : String(item)
        }).filter(Boolean)
      }
      // 兼容旧数据：逗号分隔的 id 字符串
      if (si != null && String(si).trim() !== '') {
        const ids = String(si).split(/[,，、]/).map(x => x.trim()).filter(Boolean)
        return ids.map(id => {
          const m = this.serviceCatalog.find(c => c.id === String(id))
          return m ? m.name : id
        }).filter(Boolean)
      }
      if (Array.isArray(row.services) && row.services.length) {
        return row.services.map(s => s.name || '').filter(Boolean)
      }
      return []
    },
    recordImgs(row) {
      if (!row || !row.img_urls) return []
      if (Array.isArray(row.img_urls)) return row.img_urls.filter(Boolean)
      const s = String(row.img_urls).trim()
      if (!s) return []
      return s.split(',').map(x => x.trim()).filter(Boolean)
    },
    recordServiceType(row) {
      const CriTypeMap = { '1': '日间照料', '2': '寄宿托养' }
      const raw = row.type != null && row.type !== '' ? row.type : (this.rowData.userInfo && this.rowData.userInfo.cri_type)
      if (raw == null || raw === '') return '寄宿托养'
      return CriTypeMap[raw] || CriTypeMap[String(raw)] || String(raw)
    },
    attendanceValue(row) {
      if (!row) return ''
      const v = row.attendance != null && row.attendance !== '' ? row.attendance : (row.check_status != null && row.check_status !== '' ? row.check_status : '')
      return v
    },
    attendanceText(row) {
      const v = this.attendanceValue(row)
      if (v === '' || v == null) return '—'
      const map = { 1: '正常', 2: '请假', 3: '放假', '正常': '正常', '请假': '请假', '放假': '放假' }
      return map[v] || map[String(v)] || String(v)
    },
    attendanceTagType(row) {
      const t = this.attendanceText(row)
      const map = { '正常': 'success', '放假': 'info', '请假': 'warning' }
      return map[t] || 'info'
    },
    /** 仅请假、放假不展示服务内容和服务中照片，其余照常显示 */
    showRecordServiceDetail(row) {
      const t = this.attendanceText(row)
      return t !== '请假' && t !== '放假'
    },
    openEditRecord(row) {
      this.$refs.EditServiceRecord.open(row)
    },
    handleDelete(record_id) {
      this.$confirm(`确定删除该服务记录吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          delBoardingServiceRecord(record_id).then(res => {
            if (res.status) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.getList()
            } else {
              this.$message({
                type: 'warning',
                message: res.msg
              })
            }
          })
        })
        .catch(() => {
          console.log('取消删除')
        })
    },
    // 打开修改患者信息
    handleOpenChangeOrderPatientInfo() {
      this.$refs.ChangeOrderPatientInfo.handleOpen(this.rowData)
    },
    // 打开修改护士信息
    handleOpenChangeOrderNurseInfo() {
      this.$refs.ChangeOrderNurseInfo.handleOpen(this.rowData)
    },
    // 打开取消订单信息
    handleOpenCancelOrder() {
      this.$refs.CancelOrder.handleOpen(this.rowData)
    },
    returnFn() {
      this.$router.push('/orders_boarding')
    },
    getList() {
      if (!this.rowDataId) {
        this.$message.error('缺少订单 ID，无法获取详情')
        return
      }
      this.detailLoading = true
      const params = {
        order_id: this.rowDataId
      }
      fetchBoardingOrderDetail(params)
        .then(res => {
          if (res && res.status) {
            const data = res.data || {}
            this.rowData = {
              orderInfo: data.orderInfo || null,
              userInfo: data.userInfo || null,
              nurseInfo: data.nurseInfo || [],
              nurseRecordsInfo: data.nurseRecordsInfo || [],
              couponInfo: data.couponInfo || {},
              cancelOrderInfo: data.cancelOrderInfo || null
            }
            if (this.timer) {
              clearTimeout(this.timer)
              this.timer = null
            }
            if (data.cancelOrderInfo && data.cancelOrderInfo.elapsed_time && data.cancelOrderInfo.elapsed_time !== '0秒') {
              this.delayTime = data.cancelOrderInfo.elapsed_time
              this.timer = setTimeout(() => {
                this.getList()
              }, 1000)
            }
          } else {
            this.$message.error((res && res.msg) || '获取订单详情失败')
          }
        })
        .catch(() => {
          this.$message.error('获取订单详情失败')
        })
        .finally(() => {
          this.detailLoading = false
        })
    },
    inputFn(_Text) {
      this.editForm[_Text] = (this.editForm[_Text]).replace(/[^\d]/g, '').replace(/^0{1,}/g, '')
    }
  }
}
</script>

<style lang="scss" scoped>
.boarding-detail-page {
  padding: 16px 20px 30px;
}
.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 14px;
  border-bottom: 1px solid #ececec;
}
.page-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}
.descriptionsBox {
  padding: 8px 0 0;
}
.mt20 { margin-top: 20px; }
.mt15 { margin-top: 15px; }
.info-card {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 16px 20px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.02);
}
.info-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 12px;
  border-bottom: 1px solid #f2f6fc;
}
.info-card-title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  position: relative;
  padding-left: 10px;
}
.info-card-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 14px;
  background: #26a4b2;
  border-radius: 2px;
}
.status-tag {
  font-size: 13px;
  color: #26a4b2;
  font-weight: 600;
  padding: 2px 10px;
  border-radius: 12px;
  background: rgba(38, 164, 178, 0.1);
}
.cert-imgs { display: flex; flex-wrap: wrap; gap: 10px; }
.cert-img { width: 90px; height: 90px; border-radius: 6px; border: 1px solid #ebeef5; }
.nurse-cell { line-height: 1.6; }
.nurse-name { font-weight: 600; color: #303133; }
.nurse-tel { color: #909399; font-size: 13px; }
.service-items-text { color: #606266; }
.service-list { width: 100%; }
.service-line {
  display: block;
  width: 100%;
  margin-bottom: 4px;
  padding: 2px 8px;
  background: rgba(38, 164, 178, 0.08);
  border-left: 3px solid #26a4b2;
  border-radius: 2px;
  color: #303133;
  font-size: 12px;
  line-height: 1.5;
  word-break: break-all;
  white-space: normal;
}
.service-line:last-child { margin-bottom: 0; }
::v-deep .service-item-col .cell { overflow: visible !important; white-space: normal !important; line-height: 1.6; }
.empty-text { color: #c0c4cc; }
.refund-fee { color: #f56c6c; font-weight: 600; }
.delay-time { color: #f56c6c; font-weight: 600; }
.record-table {
  margin-top: 4px;
}
.imgbox {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  .litimg2 {
    width: 44px;
    height: 44px;
    margin: 4px 6px 4px 0;
    border-radius: 4px;
    border: 1px solid #ebeef5;
    object-fit: cover;
    cursor: zoom-in;
  }
}
</style>
